/**
 * Pure helpers for the pages that ask a person to accept the privacy notice (#289) and the Terms
 * of Use (0181).
 */
import axios from 'axios';

export type LegalDocumentKind = 'privacy' | 'terms';

const REFUSAL_CODES: Readonly<Record<string, LegalDocumentKind>> = {
  privacy_notice_not_accepted: 'privacy',
  terms_not_accepted: 'terms',
};

/**
 * Which document the server says is no longer the version in force (it moved while the page was
 * open), or null when the failure is anything else.
 */
export function movedDocument(err: unknown): LegalDocumentKind | null {
  if (!axios.isAxiosError(err) || err.response?.status !== 422) return null;
  const detail: unknown = err.response.data?.detail;
  if (typeof detail !== 'object' || detail === null) return null;
  const code = (detail as { code?: unknown }).code;
  return typeof code === 'string' ? (REFUSAL_CODES[code] ?? null) : null;
}

/** What the account owes of the two documents, read from the session. */
export function owedDocuments(
  user: { privacy_notice_owed?: boolean; terms_owed?: boolean } | null,
): LegalDocumentKind[] {
  const owed: LegalDocumentKind[] = [];
  if (user?.privacy_notice_owed === true) owed.push('privacy');
  if (user?.terms_owed === true) owed.push('terms');
  return owed;
}
